import styled from "styled-components/native";
import OptionHeader from "../OptionHeader";
import { FlatList } from "react-native";
import { ProductCategory } from "@utils/constants";
import { DisplayConfigurationV2 } from "@src/types/DiamondDetail";
import CheckBox from "@components/atoms/CheckBox";
import useScreenOptionsHooks from "../../../../hooks/useScreenOptionsHooks";
import { SpaceType } from "@components/atoms/Spacer/types";
import { useJewelryConfiguratorState } from "@scenes/configurator/JewelryConfigurator/Context/JewelryConfiguratorContext";
import { useEffect, useState } from "react";
import RadioButton from "@components/atoms/RadioButton";
import { DefaultTheme } from "styled-components/native";

type JewelryBuilderCheckBoxProps = {
  productType: ProductCategory;
  configObject: DisplayConfigurationV2;
  fromReviewPage?: boolean;
  isOpen?: boolean;
  onToggle?: () => void;
  fromOrderCart?: boolean;
  fromRequest?: boolean;
  isRadioButton?: boolean;
};

const JewelryBuilderCheckBox = ({
  productType,
  configObject,
  isRadioButton,
}: JewelryBuilderCheckBoxProps) => {
  const { theme } = useScreenOptionsHooks();
  const { addToOption, jcSelectedOption } = useJewelryConfiguratorState();

  const [selectedItem, setSelectedItem] = useState<string[]>(
    configObject?.selected_item?.trim()
      ? configObject.selected_item.split(",").map((s) => s.trim())
      : jcSelectedOption.current.option_value?.[configObject.option_type] ?? []
  );

  useEffect(() => {
    setSelectedItem(
      configObject?.selected_item?.trim()
        ? configObject.selected_item?.split(",").map((s: string) => s.trim())
        : jcSelectedOption.current.option_value?.[configObject.option_type] ??
            []
    );
  }, [
    configObject.selected_item,
    jcSelectedOption.current.option_value[configObject.option_type],
  ]);

  return (
    <ContainerView>
      <HeaderContainer>
        <OptionHeader
          title={configObject.option_name}
          productType={productType}
          helperText={configObject.option_helper_text}
          disableToggleButton={configObject?.disable_modify_variation ?? false}
        />
      </HeaderContainer>
      <FlatList
        data={configObject.option_value}
        renderItem={({ item, index }) => (
          <>
            <ItemContainer>
              {isRadioButton ? (
                <RadioButton
                  key={index}
                  checked={
                    selectedItem?.includes(item?.value) ||
                    selectedItem?.includes(item?.slug)
                  }
                  label={item.label}
                  onPress={() => {
                    if (
                      selectedItem?.includes(item?.value) ||
                      selectedItem?.includes(item?.slug)
                    ) {
                      setSelectedItem([]);
                      addToOption(configObject?.option_type, [
                        configObject,
                        [item.value || item.slug],
                        isRadioButton,
                      ] as any);
                    } else {
                      setSelectedItem([item?.value || item?.slug]);
                      addToOption(configObject?.option_type, [
                        configObject,
                        [item.value || item.slug],
                        isRadioButton,
                      ] as any);
                    }
                  }}
                  margin="0"
                  labelColor={
                    selectedItem?.includes(item?.value) ||
                    selectedItem?.includes(item?.slug)
                      ? theme["core-05"]
                      : theme["core-06"]
                  }
                />
              ) : (
                <CheckBox
                  text={item.label}
                  isChecked={
                    selectedItem?.includes(item?.value) ||
                    selectedItem?.includes(item?.slug)
                  }
                  checkedFunction={() => {
                    addToOption(configObject?.option_type, [
                      configObject,
                      [item.value || item.slug],
                      isRadioButton,
                    ] as any);
                  }}
                  checkBoxSize={20}
                  labelColor={
                    selectedItem?.includes(item?.value) ||
                    selectedItem?.includes(item?.slug)
                      ? theme["core-05"]
                      : theme["core-06"]
                  }
                />
              )}
            </ItemContainer>
          </>
        )}
      />
    </ContainerView>
  );
};

export default JewelryBuilderCheckBox;

const ContainerView = styled.View`
  background-color: ${({ theme }: { theme: DefaultTheme }) => theme["core-01"]};
  border-radius: ${SpaceType.Basic}px;
`;

const HeaderContainer = styled.View`
  padding-top: ${SpaceType.Extra}px;
  padding-bottom: ${SpaceType.Extra}px;
  padding-left: ${SpaceType.Double}px;
  padding-right: ${SpaceType.Basic}px;
`;

const ItemContainer = styled.View`
  padding-top: ${SpaceType.Basic}px;
  padding-bottom: ${SpaceType.Basic}px;
  padding-left: ${SpaceType.Double}px;
  border-top-width: 1px;
  border-top-color: ${({ theme }: { theme: DefaultTheme }) => theme["core-03"]};
`;
